import { BaseModel, SaveType } from "@puntaje/shared/core"
import { Banner } from "./banners.model"

export class IframeBanner extends BaseModel {
    public iframe_url: string

    @SaveType(() => Banner) public banner: Banner
}
